import { EntityDetail } from '@/common/entityFramework/entityDetail/EntityDetail'
import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm'
import { useEntityMgr } from '@/common/entityFramework/entityView/EntityMgrContext'
import { EventList } from '@/skdr/entities/event/EventList'

export const RunDetail = () => {

  const { entityObj} = useEntityMgr();
  
  const tabSpecs = [
    { id: 'info', label: 'Info', content: <EntityForm /> },
    { id: 'eventList', label: 'Events', content: <EventList runId={entityObj.id}/> }
  ]
    
  return (
    <EntityDetail tabSpecs={tabSpecs} />
  )
}